import { api } from './api';

export const architectImagesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getArchitectImages: builder.query({
      query: (params = {}) => ({
        url: '/admin/architect-images',
        params: {
          page: params.page ?? 1,
          limit: params.limit ?? 10,
          ...(params.search && { search: params.search }),
          ...(params.sortBy && { sortBy: params.sortBy }),
          ...(params.sortOrder && { sortOrder: params.sortOrder }),
          ...(params.status !== undefined &&
            params.status !== null &&
            params.status !== '' && { status: String(params.status) }),
          ...(params.is_live === true && { is_live: 'true' }),
          ...(params.is_live === false && { is_live: 'false' }),
          ...(params.awaiting_publish === true && { awaiting_publish: 'true' }),
          ...(params.author_id != null &&
            params.author_id !== '' && { author_id: params.author_id }),
          ...(params.request_id && { request_id: params.request_id }),
          ...(params.startDate && { startDate: params.startDate }),
          ...(params.endDate && { endDate: params.endDate }),
        },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'ArchitectImage', id })),
              { type: 'ArchitectImage', id: 'LIST' },
            ]
          : [{ type: 'ArchitectImage', id: 'LIST' }],
    }),
    getArchitectImageDetail: builder.query({
      query: (id) => `/admin/architect-images/${id}`,
      providesTags: (result, error, id) => [{ type: 'ArchitectImage', id }],
    }),
    deleteArchitectImage: builder.mutation({
      query: (id) => ({
        url: `/admin/architect-images/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'ArchitectImage', id },
        { type: 'ArchitectImage', id: 'LIST' },
      ],
    }),
    deleteManyArchitectImages: builder.mutation({
      query: (ids) => ({
        url: '/admin/architect-images/bulk-delete',
        method: 'POST',
        body: { ids },
      }),
      invalidatesTags: [{ type: 'ArchitectImage', id: 'LIST' }],
    }),
    setFeaturedArchitectImages: builder.mutation({
      query: ({ ids, featured }) => ({
        url: '/admin/architect-images/set-featured',
        method: 'PATCH',
        body: { ids, featured },
      }),
      invalidatesTags: (result, error, { ids }) => [
        ...(ids || []).map((id) => ({ type: 'ArchitectImage', id })),
        { type: 'ArchitectImage', id: 'LIST' },
      ],
    }),
    toggleArchitectImagePublish: builder.mutation({
      query: (id) => ({
        url: `/admin/architect-images/${id}/toggle-publish`,
        method: 'PATCH',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'ArchitectImage', id },
        { type: 'ArchitectImage', id: 'LIST' },
      ],
    }),
    bulkToggleArchitectImagePublish: builder.mutation({
      query: ({ ids, action }) => ({
        url: '/admin/architect-images/bulk-toggle-publish',
        method: 'POST',
        body: { ids, action },
      }),
      invalidatesTags: [{ type: 'ArchitectImage', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetArchitectImagesQuery,
  useGetArchitectImageDetailQuery,
  useDeleteArchitectImageMutation,
  useDeleteManyArchitectImagesMutation,
  useSetFeaturedArchitectImagesMutation,
  useToggleArchitectImagePublishMutation,
  useBulkToggleArchitectImagePublishMutation,
} = architectImagesApi;
